import React, { Component } from 'react';

import { APIHandler, ShowcaseCollection, DataHandler, ContentHeader, BackImage } from 'C4';
import PropTypes from 'prop-types';
import { baseAppId } from 'settings';

export default class ShowcaseCollectionView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stands: [],
    };
  }

  componentWillMount() {
    this.getStandsAndFloor();
  }

  getStandsAndFloor() {
    APIHandler.getExhibitionStands(baseAppId).then((res) => {
      this.setState({ stands: res });
    });
  }

  render() {
    const { stands } = this.state;
    const params = new URLSearchParams(window.location.search);
    if (stands.length === 0) {
      return <div />;
    }

    return (
      <div className="showcaseCollectionViewContainer">
        <BackImage />
        <div className="showcaseContainer">
          <ContentHeader header="Showcases" icon="" line={false} />
          <div className="showcaseCountriesGrid">
            {stands.map((stand) => (
              <ShowcaseCollection stands={stand.tiles_sorted_by_position} category={stand.title} key={stand.id} />
            ))}
            <style>{'\
          .fancybox-slide--iframe .fancybox-content { max-width  : 960px; margin: 0; }'}</style>
            {params.get('header') && <style>{'\
          .header { display: none !important; } .showcaseCollectionViewContainer { margin-top: 3rem !important; }'}</style>}
          </div>
        </div>
      </div>
    );
  }
}

ShowcaseCollectionView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape().isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
};

ShowcaseCollectionView.defaultProps = {
  // headerSubtitle: '',
};
